export const mobileZoomMin = '100'
export const mobileZoomMax = '800'

export const ZoomResponseDelay = 5000

export const ZOOM_STEP = 20
export const ZOOM_MULTIPLIER = 100
